import "assets/css/v2/colors.module.scss";

const FailedIconWithBackground = () => {
  return (
    <svg
      width="57"
      height="55"
      viewBox="0 0 57 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="28.4648"
        cy="27.5"
        rx="28"
        ry="27.5"
        style={{ fill: "var(--red-background)" }}
      />
      <g clipPath="url(#clip0_6104_30527)">
        <path
          d="M28.5 41C35.9558 41 42 34.9558 42 27.5C42 20.0442 35.9558 14 28.5 14C21.0442 14 15 20.0442 15 27.5C15 34.9558 21.0442 41 28.5 41Z"
          fill="#FF4445"
        />
        <path
          d="M23.6406 32.3606L28.5006 27.5006L33.3606 22.6406"
          style={{ stroke: "var(--red-stroke)" }}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M23.6406 22.6406L28.5006 27.5006L33.3606 32.3606"
          style={{ stroke: "var(--red-stroke)" }}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6104_30527">
          <rect
            width="27"
            height="27"
            fill="white"
            transform="translate(15 14)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default FailedIconWithBackground;
